import root from './_root';

/** Built-in value references. */
var Reflect = root.Reflect;

export default Reflect;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ckeditor/ckeditor5-utils/src/lib/lodash/_Reflect.js
// module id = null
// module chunks = 